<template>
  <div class="pcBox">
    <div class="pcBox-header" :style="setHeaderLineTheme()">
      <div class="clearfix">
        <div class="div_left logo_wrapper">
          <span class="logo"></span>
          <span style="margin-left: 10px">{{ $t("common.checkout") }}</span>
        </div>
        <!-- <div class="div_right" @click="changeL(languageTitle)">
          <span class="lgIcon"></span>
          <span style="margin-left: 6px;">{{ languageTitle }}</span>
        </div> -->
        <!-- 切换语言 -->
        <div class="div_select_right">
          <el-select
            v-model="languagekey"
            placeholder="Select"
            size="large"
            style="width: 240px"
            @change="changeL(languagekey)"
          >
            <el-option
              v-for="item in language"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
          <div
            class="div_close_button"
            @click="showCloseDialog"
            v-if="Boolean(showReturnButton)"
          >
            <span class="close-icon">✕</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pcBox-center">
      <div class="topStatus">
        <div class="top clearfix">
          <div class="div_left" style="display: flex;">
            <span class="statusIcon">
              <div
                v-if="!subError"
                class="success-icon"
                :style="setCheckTheme()"
              >
                <span class="check">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4.24219"
                      y="14.1433"
                      width="20"
                      height="6"
                      rx="3"
                      transform="rotate(45 4.24219 14.1433)"
                      fill="white"
                    />
                    <rect
                      x="32.5273"
                      y="14.1433"
                      width="26"
                      height="6"
                      rx="3"
                      transform="rotate(135 32.5273 14.1433)"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
              <img v-if="subError" src="../../assets/pc/fork_red.svg" alt />
            </span>
            <span class="statusText" v-if="!subError && !overtimeStatus">
              {{ $t("common.subscriptionReceived") }}
            </span>
            <span class="statusText" v-if="overtimeStatus">
              {{ $t("pc.overtimeStatusInfo") }}
            </span>
            <span class="statusText" v-if="subError">
              {{ failStatusInfo }}
            </span>
          </div>
          <!-- <div class="div_right" v-if="!subError">
            <span
              style="font-size:16px;color:rgba(102,102,102,1);"
              v-if="successStatus"
            >
              {{ $t("pc.payTotel1") }}
            </span>
            <span
              style="font-size:16px;color:rgba(102,102,102,1);"
              v-if="waitStatus || overtimeStatus"
            >
              {{ $t("pc.payTotel") }}
            </span>
            <span
              style="font-size:24px;line-height:24px;font-weight:600;color:rgba(255,121,40,1);margin-left:16px"
            >
              <span style="font-size: 16px;margin-top: -3px;">
                {{ goodInfo.currencySymbol }}
              </span>
              {{ goodInfo.totalFee }}
            </span>
          </div> -->
        </div>
        <div class="timeBox" v-if="!subError">
          {{ $t("pc.leftTime") }}
          <span :style="setCountdownTheme()">{{ countDownList }}</span>
          {{ $t("pc.rightTime") }}
        </div>
      </div>
      <div class="botGoods" v-if="!subError">
        <div class="goods-left">
          <div class="info-card">
            <div class="part clearfix">
              <span class="leftTitle div_left">
                {{ $t("common.subOrderNo") }}
              </span>
              <span class="rightInfo div_right">
                {{ goodInfo.merchantStageNoClear }}
              </span>
            </div>
            <div class="part clearfix">
              <span class="leftTitle div_left">
                {{ $t("pc.goodsName") }}
              </span>
              <span class="rightInfo div_right">
                {{ goodInfo.productName }}
              </span>
            </div>
          </div>
        </div>
        <!-- 课程订阅信息 -->
        <div
          class="goods-right"
          v-if="goodInfo && goodInfo.subscriptionModel == 1"
        >
          <div class="recurring-card">
            <div class="rec-title">
              {{ $t("common.installmentPlan") }}
            </div>
            <div class="rec-row">
              <span class="rec-label"
                >{{ goodInfo.payDateTitle }}: {{ goodInfo.payDateDetail }}</span
              >
              <!-- <span class="rec-value">{{ goodInfo.payDate  }}1111</span> -->
            </div>
            <div class="rec-row rec-desc">
              <span class="rec-label"
                >{{ goodInfo.goodsTitle }}: {{ goodInfo.goodsName }}</span
              >
              <!-- <span class="rec-value">{{ goodInfo.goodsName }}</span> -->
            </div>
            <div class="rec-price">
              <div class="price-line">
                <span class="amount" :style="setAmountTheme()">{{
                  goodInfo.amount
                }}</span>
                <span class="offer-badge" v-if="goodInfo.coupon"
                  >SPECIAL OFFER</span
                >
              </div>
              <div class="thereafter">
                {{ goodInfo.coupon }}
              </div>
            </div>
          </div>
        </div>
        <!-- 会员订阅 -->
        <div class="goods-right" v-else>
          <div class="recurring-card">
            <div class="rec-title">
              {{ $t("common.recurringSubscription") }}
            </div>
            <div class="rec-row">
              <!-- <span class="rec-label">{{ $t('common.paymentDateLabel') }}:</span> -->
              <span class="rec-label"
                >{{ goodInfo.payDateTitle }}: {{ goodInfo.payDateDetail }}</span
              >
            </div>
            <div class="rec-row rec-desc">
              <span class="rec-label"
                >{{ goodInfo.goodsTitle }}: {{ goodInfo.goodsName }}</span
              >
              <!-- <span class="rec-value">{{  goodInfo.goodsName }}</span> -->
            </div>
            <div class="rec-price">
              <div class="price-line">
                <!-- <span class="currency">{{ goodInfo.currencySymbol }}</span> -->
                <span class="amount" :style="setAmountTheme()">{{
                  goodInfo.amount
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pcBox-footer" v-if="overtimeStatus">
      <div class="resultIcon">
        <!-- <img
          v-if="successStatus"
          src="../../assets/pc/payment_success_pc.png"
          width="140"
          alt
        /> -->
        <!-- <img
          v-if="failStatus"
          src="../../assets/pc/payment_failure_pc.png"
          width="140"
          alt
        /> -->
        <img
          v-if="overtimeStatus"
          src="../../assets/pc/order_invalid_pc.png"
          width="140"
          alt
        />
      </div>
      <div class="resultText" v-if="successStatus">
        {{ $t("pc.successText1") }}
        <span @click="backRrturnUrl" style="text-decoration:underline">
          {{ $t("pc.successText2") }}
        </span>
      </div>
      <div class="resultText" v-if="overtimeStatus">
        {{ $t("pc.overtimeText1") }}
        <span @click="failBackRrturnUrl" style="text-decoration:underline">
          {{ $t("pc.overtimeText2") }}
        </span>
        {{ $t("pc.overtimeText3") }}
      </div>
    </div>
    <div
      class="pcBox-footer"
      v-if="
        !subError &&
          goodInfo.payWayConfigList &&
          goodInfo.payWayConfigList.length > 0 &&
          !overtimeStatus
      "
    >
      <div class="title">{{ $t("common.paySubMethods") }}</div>
      <div class="payWays">
        <div v-for="(item, index) in goodInfo.payWayConfigList" :key="index">
          <!-- 判断如果payWayName是applepay且supportsApplePay为ture或者 判断如果payWayName是googlepay或者isGooglePaySupported为true或者不含有googlepay或者ApplePay-->
          <div
            v-if="
              (item.payWayCode == 9 && supportsApplePay()) ||
                item.payWayCode != 9
            "
            class="part hoverPart clearfix"
            :key="item.payWayName"
            :style="
              setPayMethodTheme(
                checkoutValue == item.curPayProductData.productCode,
                hoverIndex === index
              )
            "
            @mouseenter="hoverIndex = index"
            @mouseleave="hoverIndex = null"
            @click="
              selectPay(item.curPayProductData.productCode, item.payWayCode)
            "
          >
            <span class="payIcon div_left">
              <img :src="item.logoUrl" alt />
            </span>
            <span class="payPro">
              <van-cell
                v-if="item.curPayProductData.productCode !== 31"
                center
                :value="item.payWayName"
              />
              <van-cell
                v-else-if="item.curPayProductData.productCode == 31"
                :title="item.payWayName"
                label="请使用手机打开微信扫一扫，完成扫码付款。"
              ></van-cell>
            </span>
          </div>
          <!-- 如果是选中FPX支付 -->
          <div
            v-if="
              item.curPayProductData.productCode == 46 && checkoutValue == 46
            "
          >
            <p class="mol_tip">选择您的银行</p>
            <div id="molpay_ebanking_fpx_MY-container"></div>
          </div>
        </div>
        <div class="payBtn-group " v-if="!subError">
            <!-- 授权协议选择 -->
            <div class="agreement-group">
            <van-checkbox
              v-model="isAgree"
              v-if="achAgreement"
              @change="handleAgreement"
              shape="square"
              color="#ffaa0a"
            >
            </van-checkbox>
            <div class="agreement-text" v-if="achAgreement">
              <!-- <span>我已阅读并同意</span> -->
              <agreement-popup
                @agreement-confirmed="handleAgreementConfirmed"
                :position="position"
                :amount="goodInfo.totalFee"
                @popup-closed="handlePopupClosed"
              />
            </div>
          </div>
          <div class="payBtn" @click="goPay" :style="setBtnTheme()" id="">
            {{ $t("common.confirm") }}
          </div>
        </div>

        <!-- <div class="googleOrApplePayButton" id="googleOrApplePayButton"></div> -->
      </div>
    </div>
    <div
      class="pcBox-footer"
      v-if="
        !subError &&
          goodInfo.payWayConfigList &&
          goodInfo.payWayConfigList.length == 0
      "
    >
      <div class="resultText">
        <div class="result-icon">
          <img src="@/assets/pc/fork_red.svg" alt="错误" />
        </div>
        <div class="result-message">
          {{ $t("common.noPayWay") }}
        </div>
      </div>
    </div>
    <!-- loading盒子 -->
    <div class="loadingBox" v-if="loadingFlag">
      <div class="bg"></div>
      <div class="centerBox">
        <img src="../../assets/pc/loading.gif" alt />
        <div>{{ $t("common.loadingCommonText") }}</div>
      </div>
    </div>
    <div class="payResultBox" v-if="payResult">
      <div class="bg"></div>
      <div class="payResultCenterBox">
        <div class="title clearfix">
          <div class="div_left">
            <!-- <img :src="logoInfo.path" alt /> -->
            <!-- {{ checkoutValue == 68 ? 'Alipay HK' : 'Alipay' }} -->
          </div>
          <div class="div_right" @click="closePayResult">
            <span></span>
          </div>
        </div>
        <div class="centerContent">
          <!-- 其它 -->
          <qrcode
            class="qrcode"
            :value="qrcodeUrl"
            :options="{ size: 300 }"
            v-if="qrcodeType === 'QRCODE_NORMAL'"
            >{{ qrcodeUrl }}</qrcode
          >
          <!-- paynow支付 -->
          <div v-else ref="qrcodeRef" style="text-align: center;"></div>
          <div class="botText" style="margin-top:14px;">
            <template v-if="qrcodeType === 'QRCODE_NORMAL'">
              {{ $t("pc.scanCodePart1") }}
              <span>{{ logoInfo.name }}</span>
              {{ $t("pc.scanCodePart2") }}
            </template>

            <!--支付宝香港-->
            <template v-else-if="qrcodeType === 'QRCODE_ALI_HK' ">
              <iframe
                :src="qrcodeUrl"
                frameborder="0"
                width="400"
                height="400"
                class="ali-hk-frame"
              ></iframe>
              <div style="margin-top:14px">
                {{ $t("pc.aliHKScanCodePart1") }}
                <span>{{ $t("pc.aliHKScanCodeApp") }}</span>
                {{ languageTitle == "English" ? $t("pc.aliHKPay") : "" }}
              </div>
            </template>
            <!-- paynow -->
            <template v-else>
              {{ $t("pc.paynowScanCodeNormal1") }}
              <span>{{ $t("pc.paynowScanCodeApp") }}</span>
              {{
                languageTitle == "English" ? $t("pc.paynowScanCodeNormal2") : ""
              }}
            </template>
          </div>
          <div class="botText">
            {{ qrcodeType === "QRCODE_NORMAL" ? $t("pc.scanCodePart3") : "" }}
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="googleOApplePayShow"
      get-container="body"
      closeable
      close-icon="close"
      position="center"
      :style="{ minHeight: '200px', width: '320px', borderRadius: '10px' }"
    >
      <div class="googleOrApplePayButton-wrap">
        <p class="tips">{{ $t("common.clickPayButtonTip") }}</p>
        <img
          class="loading-img"
          v-if="loading"
          src="../../assets/pc/tal_button_loading_black.png"
          alt
        />
        <div class="googleOrApplePayButton" id="googleOrApplePayButton"></div>
        <p v-if="checkoutValue == 66" class="apple-pay-subscription-tip">
          {{ $t("common.applePayUnionPayUnsupportedTip") }}
        </p>
      </div>
    </van-popup>
      <!-- Airwallex卡支付 -->
      <airwallex-payment
        v-model="airwallexPopupShow"
        :responseData="airwallexResponseData"
        :client-secret="clientSecret"
        :amount="goodInfo.totalFee"
        :currency="goodInfo.currency"
        :environment="goodInfo.airwallexEnv === 'LIVE' ? 'prod' : 'demo'"
        :is-mobile="false"
        @payment-success="handleAirwallexSuccess"
        @payment-error="handleAirwallexError"
        @initialized="handleAirwallexInitialized"
        @report-log="reportLog"
      />
       <!-- ach支付AchPaymentCardList -->
    <pcAchPayment
      v-if="showAchPayment"
      :cardList="cardList"
      :showPopup="showAchPayment"
      :environment="environment"
      :clientKey="clientKey"
      :initialSelectedCardId="initialSelectedCardId"
      :showAchPayment="showAchPayment"
      @goPay="goPay"
      @delete-card="deleteCard"
      @card-selected="cardSelected"
      @close-popup="closeAchPayment"
      @payment-completed="handlePaymentCompleted"
      @payment-error="handlePaymentError"
      @payment-submit="handlePaymentSubmit"
      @payment-change="handlePaymentChange"
    />
  </div>
</template>
<script>
import "@/style/pc/reset.css";
import utils from "@/utils/index";
import api from "@/api/api";
import Qrcode from "@xkeshi/vue-qrcode";

import { Notify, Toast } from "vant";
import indexMixin from "../../mixins/index";
import subscriptionMixin from "../../mixins/subscription";
import themeMixin from "@/mixins/theme";
import AirwallexPayment from "@/components/subAirwallexPayment.vue";
import pcAchPayment from "@/components/subscription/pcAchPayment.vue";
import AgreementPopup from "@/components/subscription/AgreementPopup.vue";

// 引入主题色

// import { createElement, loadAirwallex, getElement, confirmPaymentIntent } from 'airwallex-payment-elements';

export default {
  components: {
    qrcode: Qrcode,
    AirwallexPayment,
    pcAchPayment,
    AgreementPopup
  },
  mixins: [indexMixin, themeMixin, subscriptionMixin],
  data() {
    return {
      payProductPcList: [43, 32, 64, 65, 66, 67, 68, 81],
      language: [
        { text: "English", value: "0" },
        { text: "简体中文", value: "1" },
        { text: "Français", value: "2" },
        { text: "日本語", value: "3" },
        { text: "한국어", value: "4" }
      ],
      languageTitle: "English",
      languagekey: "0",
      goodInfo: {},
      // 新增：后台可选的订阅信息对象
      queryStatus: null,
      timeInfoFlag: false,
      countDownList: "00:00:00",
      checkoutValue: "",
      qrcodeUrl: "",
      successStatus: false,
      overtimeStatus: false,
      waitStatus: false,
      failStatus: false,
      loadingFlag: false,
      loading: false,
      payResult: false,
      logoInfo: {
        path: "",
        name: ""
      },
      qrcodeType: "",
      paynowImg: require("../../assets/pc/paynowLogo.png"),
      placeholder: this.$t("moblie.popupTitle"),
      fpxType: "",
      fpxName: "",
      issuers: [],
      onlineBankingMalaysiaComponent: null,
      fpxPaymentMethod: null,
      highlightedIssuers: [],
      clientKey: "",
      environment: "",
      countryCode: "",
      clientSecret: "",
      googleOApplePayShow: false,
      payTradeNo: "",
      isAgree: true,
      position: "center",
      showAchPayment: false,
      achAgreement: false,
      initialSelectedCardId: null,
      bankAccountListToken: "",
      cardList: [],
      isFormValid: true,
      extendParam: "",
      // 保存上次的协议勾选状态，用于弹窗关闭时的状态恢复
      lastAgreementState: true,
      // 标记是否是程序手动修改isAgree值，而不是用户点击
      isProgrammaticChange: false,
      bankAccountToken: null,
      showReturnButton: 0,
      cancelUrl: "",
      airwallexPopupShow: false,
      airwallexResponseData: {},
      cardElement: null,
      cardNumber: null,
      expiry: null,
      cvc: null,
      domElement: null,
      hoverIndex: null,
      failText: "",
      subError: false,
      failStatusInfo: "",
      // 定时器变量 - 分离不同功能的定时器避免冲突
      countdownInterval: null, // 倒计时定时器
      queryInterval: null, // 查询订单状态定时器
      subscriptionQueryInterval: null, // 查询订阅状态定时器
      paymentIntent: {},
    };
  },
  methods: {
    /**
     * @method sanitizeAndValidateUrl
     * @description 清理和验证URL，处理各种可能的URL格式问题
     * @param {String} url 原始URL
     * @returns {String|null} 处理后的有效URL，如果无法修复则返回null
     */
    sanitizeAndValidateUrl(url) {
      if (!url || typeof url !== "string") {
        return null;
      }

      let processedUrl = url.trim();

      try {
        // 处理多重URL编码
        let decodedUrl = processedUrl;
        let maxDecodeAttempts = 3; // 最多尝试解码3次，防止无限循环

        for (let i = 0; i < maxDecodeAttempts; i++) {
          try {
            const decoded = decodeURIComponent(decodedUrl);
            if (decoded === decodedUrl) {
              break; // 如果解码后没有变化，说明已经完全解码
            }
            decodedUrl = decoded;
          } catch (e) {
            break; // 解码失败，使用当前结果
          }
        }

        processedUrl = decodedUrl;

        // 添加协议前缀（如果缺失）
        if (!/^https?:\/\//i.test(processedUrl)) {
          processedUrl = "https://" + processedUrl;
        } else if (processedUrl.startsWith("http://")) {
          processedUrl = processedUrl.replace("http://", "https://");
        }

        // 使用原生URL构造函数验证URL格式
        const urlObj = new URL(processedUrl);

        // 基本安全检查
        const hostname = urlObj.hostname.toLowerCase();

        // 检查是否为有效的域名格式
        const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!domainRegex.test(hostname)) {
          console.warn("Invalid domain format:", hostname);
          return null;
        }

        // 防止一些常见的恶意URL
        const blockedPatterns = [
          /^javascript:/i,
          /^data:/i,
          /^vbscript:/i,
          /^file:/i
        ];

        for (const pattern of blockedPatterns) {
          if (pattern.test(processedUrl)) {
            console.warn("Blocked potentially dangerous URL:", processedUrl);
            return null;
          }
        }

        return urlObj.toString();
      } catch (error) {
        console.warn(
          "URL validation failed:",
          error.message,
          "for URL:",
          processedUrl
        );
        return null;
      }
    },
    /**
     * @method showCloseDialog
     * @description 点击关闭按钮，跳转到 cancelUrl
     */
    showCloseDialog() {
      if (this.cancelUrl) {
        // 跳转到业务方传入的 cancelUrl
        const sanitizedUrl = this.sanitizeAndValidateUrl(this.cancelUrl);

        if (sanitizedUrl) {
          try {
            // 使用 window.open 在当前窗口跳转
            window.open(sanitizedUrl, "_self");
          } catch (error) {
            console.error("Failed to navigate to URL:", error);
            Notify({
              type: "danger",
              message: "跳转失败，URL格式错误"
            });
          }
        } else {
          // URL验证失败
          console.error("Invalid cancelUrl:", this.cancelUrl);
          Notify({
            type: "danger",
            message: "跳转失败，URL格式不正确"
          });
        }
      } else {
        // 如果没有 cancelUrl，则执行默认的返回操作
        Notify({
          type: "danger",
          message: "跳转失败，请稍后重试"
        });
      }
    },
    /**
     * @method airwallexInitSelect a payment method

     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 卡支付
     */
    // initializeAirwallex() {
    //   loadAirwallex({
    //     env: 'demo', // Can choose other production environments, 'staging | 'demo' | 'prod'
    //     origin: window.location.origin, // Setup your event target to receive the browser events message
    //   }).then(() => {
    //     this.cardNumber = createElement("cardNumber");
    //     this.expiry = createElement("expiry");
    //     this.cvc = createElement("cvc");
    //     this.domElement = this.cardNumber.mount("cardNumber");
    //     this.expiry.mount("expiry");
    //     this.cvc.mount("cvc");
    //   });
    // },

    /**
     * @method changeL
     * @param {string} title 语种
     * @description 语言切换
     */
    changeL(title) {
      const languages = {
        "0": { locale: "en", title: "English" },
        "1": { locale: "zh", title: "简体中文" },
        "2": { locale: "fr", title: "Français" },
        "3": { locale: "ja", title: "日本語" },
        "4": { locale: "ko", title: "한국어" }
      };
      const selectedLanguage = languages[title];
      if (selectedLanguage) {
        this.$i18n.locale = selectedLanguage.locale;
        this.languageTitle = selectedLanguage.title;
        localStorage.setItem("lang", selectedLanguage.locale);
      }
      this.setGoodInfo();
    },
    /**
     * @methods setGoodInfo
     * @description 获取页面信息
     */
    setGoodInfo() {
      // Generated by AI start - Cursor - 2024-12-19
      let merchantCode = utils.getUrlParmas(window.location.href).merchantCode;
      let merchantStageNo = utils.getUrlParmas(window.location.href)
        .merchantStageNo;
      // let checkoutType = utils.getUrlParmas(window.location.href).checkoutType || 1;
      let checkoutToken = utils.getUrlParmas(window.location.href)
        .checkoutToken;

      // 处理showReturnButton参数，添加更好的容错处理
      const showReturnButtonStr = utils.getUrlParmas(window.location.href)
        .showReturnButton;
      console.log("原始showReturnButton值:", showReturnButtonStr);

      // 如果获取到的值是字符串"1"或数字1，则为1，否则为0
      if (showReturnButtonStr === "1" || showReturnButtonStr === 1) {
        this.showReturnButton = 1;
      } else if (showReturnButtonStr === "0" || showReturnButtonStr === 0) {
        this.showReturnButton = 0;
      } else {
        // 尝试转换为数字，如果NaN则默认为0
        const parsed = parseFloat(showReturnButtonStr);
        this.showReturnButton = isNaN(parsed) ? 0 : parsed;
      }

      console.log("解析后的showReturnButton:", this.showReturnButton);
      this.cancelUrl = utils.getUrlParmas(window.location.href).cancelUrl || "";
      // Generated by AI end
      this.loadingFlag = true;

      api.apiMethod.subscriptionCheckoutShow
        .post(
          {
            merchantCode: merchantCode,
            merchantStageNo: merchantStageNo,
            checkoutType: 1
          },
          {
            checkoutToken: checkoutToken,
            timezone: this.getTimeZone()
          }
        )
        .then(res => {
          this.loadingFlag = false;
          console.log(res.data);

          this.reportLog({
            eventId: "05_01_01_00",
            msg: res.data.subMsg
          });
          if (res.data.code === 10000) {
            console.log(this.goodInfo, "=====11111=this.goodInfo===========");
            res.data.data.payWayConfigList =
              this.payWayConfigList(
                res.data.data.payWayConfigList,
                this.payProductPcList
              ) || [];
            console.log(
              res.data.data.payWayConfigList,
              "res.data.data.payWayConfigList"
            );
            this.goodInfo = res.data.data;
            // 初始化支付产品
            if (this.goodInfo.payWayConfigList) {
              this.goodInfo.payWayConfigList.map(item => {
                if (item.curPayProductData.productCode === 81) {
                  this.bankAccountListToken =
                    item.curPayProductData.bankAccountListToken;
                  // 如果没有选择已阅读协议，则提示
                  if (!this.isAgree) {
                    Notify({ type: "warning", message: "请先阅读并同意协议" });
                    return false;
                  }
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                  this.clientKey = item.curPayProductData.adyenClientKey;
                }
              });
            }
            if (this.goodInfo.timeOut) {
              if (this.goodInfo.timeOut > 0) {
                // 倒计时
                this.countDown(this.goodInfo.timeOut);
              }
            }
            // 开启轮询
            this.subscriptionQueryOrder();
            this.reportLog({
              eventId: "05_01_02_00",
              msg: res.data.subMsg
            });
          } else {
            this.reportLog({
              eventId: "05_01_01_00",
              msg: res.data.subMsg
            });
            Notify({ type: "warning", message: res.data.subMsg });
            this.subError = true;
            this.$router.push({
              path: "/error",
              query: { msg: res.data.subMsg }
            });
            this.failStatusInfo = res.data.subMsg;
          }
        });
    },
    /**
     * @method subStatusResult
     * @param {String} status
     * @description 根据支付状态改变结果
     */
    subStatusResult(status) {
      this.payResult = false;
      if (status === 2) {
        // 成功
      } else if (status === 7) {
        // 超时
        this.successStatus = false;
        this.overtimeStatus = true;
        // this.waitStatus = false;
        // this.failStatus = false;
      } else {
        // 跳成功页
        this.backRrturnUrl();
      }
    },
    refreshQrcode() {
      // 请求接口subscriptionCheckoutPay
      let checkoutToken = utils.getUrlParmas(window.location.href)
        .checkoutToken;
      let params = {
        checkoutType: 1,
        businessCode: this.goodInfo.businessCode,
        merchantCode: this.goodInfo.merchantCode,
        merchantStageNo: this.goodInfo.merchantStageNo,
        productCode: this.checkoutValue,
        payWayCode: this.payWayCode,
        payWayName: this.payWayName,
        merchantPayNo: utils.getUrlParmas(window.location.href).merchantPayNo,
        extendParam: this.extendParam, // string格式
        env: "02"
      };
      api.apiMethod.subscriptionCheckoutPay
        .post(params, { checkoutToken: checkoutToken })
        .then(res => {
          if (res.data.code === 10000) {
            this.qrcodeUrl = JSON.parse(res.data.data.subscriptionData).url;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * @method goPay
     * @description 点击支付
     */
    goPay(payType) {
      this.reportLog({
        eventId: "05_03_01_00",
        msg: this.checkoutValue
      });
      // 如果是ach支付
      if (
        this.checkoutValue === 81 &&
        (!payType ||
          (payType.type !== "cardPayment" && payType.type !== "newCardPayment"))
      ) {
        // 如果勾选了协议，则展示ach支付
        if (this.isAgree) {
          this.showAchPayment = true;
          this.fetchCardList();
          return false;
        } else {
          Notify({ type: "warning", message: "请先阅读并同意协议" });
          return false;
        }
      }
      // 处理卡片支付
      if (payType && payType.type === "cardPayment") {
        this.bankAccountToken = payType.bankAccountToken;
        // 设置支付参数
        this.extendParam = JSON.stringify({
          bankAccountToken: this.bankAccountToken
        });
      }
      // 用payWayCode匹配出payWayName
      this.goodInfo.payWayConfigList.map(item => {
        if (item.curPayProductData.productCode === this.checkoutValue) {
          this.payWayCode = item.payWayCode;
          this.payWayName = item.payWayName;
        }
      });

      // Generated by AI start - Cursor - 2024-12-19
      let checkoutToken = utils.getUrlParmas(window.location.href)
        .checkoutToken;
      let params = {
        checkoutType: 1,
        businessCode: this.goodInfo.businessCode,
        merchantCode: this.goodInfo.merchantCode,
        merchantStageNo: this.goodInfo.merchantStageNo,
        productCode: this.checkoutValue,
        payWayCode: this.payWayCode,
        payWayName: this.payWayName,
        merchantPayNo: utils.getUrlParmas(window.location.href).merchantPayNo,
        extendParam: this.extendParam, // string格式
        webExtendParam: this.extendParam,
        env: "02",
      };
      // Generated by AI end

      if (!this.checkoutValue) {
        Notify({ type: "warning", message: this.$t("common.payMethods") });
      } else {
        this.loadingFlag = true;
        api.apiMethod.subscriptionCheckoutPay
          .post(params, { checkoutToken: checkoutToken })
          .then(res => {
            this.loadingFlag = false;
            console.log(res.data);
            if (res.data.code === 10000) {
              // 处理成功响应
              this.reportLog({
                eventId: "05_03_02_00",
                payCode: this.checkoutValue,
                msg: res.data.subMsg
              });
              // 如果是可订阅，则跳转
              if (res.data.data.status == 2) {
                switch (this.checkoutValue) {
                  // 67 cn 68 hk,"Airwallex 二维码订阅"
                  case 67:
                  case 68:
                  case 43: {
                    this.loadingFlag = true;
                    // 订阅接口为1取url上的参数
                    // 状态为2跳转url，否则跳url上的参数returnurl
                    let url = JSON.parse(res.data.data.subscriptionData).url;
                    window.location.href = url;
                    // alipay stripe
                    this.reportLog({
                      eventId: "05_04_01_00",
                      msg: res.data.subMsg
                    });
                    this.subscriptionQueryOrder();
                    break;
                  }
                  case 32: {
                    // card stripe
                    this.loadingFlag = true;
                    let url = JSON.parse(res.data.data.subscriptionData).url;
                    window.location.href = url;
                    console.log("11 Paypal支付  26支付宝国际支付");
                    this.subscriptionQueryOrder();
                    break;
                  }
                  // 64,"Airwallex 卡订阅"
                  case 64: {
                    this.handleSubscriptionPaymentCase(64, res, "PC");
                    break;
                  }
                  // 65,"Google Pay 订阅"
                  case 65: {
                    this.handleSubscriptionPaymentCase(65, res);
                    break;
                  }
                  // 66,"Apple Pay 订阅"
                  case 66: {
                    this.handleSubscriptionPaymentCase(66, res);
                    break;
                  }
                  default:
                    break;
                }
              } else {
                // 如果是不可订阅，则跳转
                this.reportLog({
                  eventId: "05_04_02_00",
                  msg: res.data.subMsg
                });
                window.location.href =
                  utils.getUrlParmas(window.location.href).returnUrl || "";
              }
            } else {
              // 失败
              this.subStatusResult(2);
              this.reportLog({
                eventId: "05_03_02_00",
                msg: res.data.subMsg
              });
            }
          });
      }
    },
    /**
     * @method closePayResult
     * @description 关闭弹窗
     */
    closePayResult() {
      this.queryStatus && clearInterval(this.queryStatus);
      this.payResult = false;
      this.setGoodInfo();
    },

    /**
     * @method selectPay
     * @param {String} payCode 支付方式
     * @description 选择支付方式
     */
    selectPay(payCode) {
      console.log(payCode, "====payCode");
      this.checkoutValue = payCode;

       // 如果是ach支付
       if (payCode === 81) {
        // 协议按钮展示
        this.achAgreement = true;
      } else {
        this.achAgreement = false;
      }
      this.reportLog({
        eventId: "05_02_01_00",
        msg: payCode
      });
    },
    /**
     * @method backRrturnUrl
     * @description 支付状态返回时，跳转到returnUrl
     */
    backRrturnUrl() {
      window.location.href =
        utils.getUrlParmas(window.location.href).returnUrl || "";
    },
    /**
     * @method failBackRrturnUrl
     * @description 支付失败回到收银台页面
     */
    failBackRrturnUrl() {
      // url获取cancelUrl参数
      window.location.href =
        utils.getUrlParmas(window.location.href).cancelUrl || "";
    },
     // 获取银行卡列表
     async fetchCardList() {
      this.loading = true;
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      let bankAccountListToken = this.bankAccountListToken;
      let merchantPayNo = utils.getUrlSearch("merchantPayNo");
      try {
        api.apiMethod.subscriptionGetCardList
          .post(
            {
              businessCode: this.goodInfo.businessCode,
              merchantPayNo: merchantPayNo
            },
            {
              checkoutToken: checkoutToken,
              bankAccountListToken: bankAccountListToken
            }
          )
          .then(res => {
            console.log(res, "====res");
            if (res.data.code === 10000) {
              this.cardList = res.data.data;
              if (this.cardList.length > 0) {
                this.initialSelectedCardId = this.cardList[0].bankAccountToken;
              }
              this.reportLog({
                eventId: "GETCARD_PC",
                msg: this.checkoutValue
              });
            } else {
              // 设置为新卡支付模式
              this.cardList = [];
              this.reportLog({
                eventId: "GETCARD_ERROR_PC",
                msg: this.checkoutValue
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.error("Error fetching card list:", error);
        this.loading = false;
        this.reportLog({
          eventId: "GETCARD_ERROR_PC",
          msg: this.checkoutValue
        });
      }
    },
    /**
     * @method handleAgreement
     * @description 处理协议勾选变化
     */
    handleAgreement(val) {
      // 只有当val有值时(用户实际点击)才记录日志，防止因程序修改isAgree导致的额外事件记录
      if (val !== undefined) {
        this.reportLog({
          eventId: "AGREEMENT_PC",
          msg: this.checkoutValue
        });
      }
    },
    /**
     * @method handleAgreementConfirmed
     * @description 自动勾选协议
     */
    handleAgreementConfirmed() {
      // 自动勾选协议
      this.isAgree = true;

      // 添加日志记录
      this.reportLog({
        eventId: "AGREEMENT_CONFIRMED_PC",
        msg: this.checkoutValue || "ACH"
      });
    },
    /**
     * @method handlePopupClosed
     * @description 弹窗关闭时的处理逻辑，如果用户已同意则设置isAgree为true，否则保持原值
     */
    handlePopupClosed(data) {
      if (data && data.hasAgreed) {
        // 如果之前isAgree是false，现在应该设为true
        if (!this.isAgree) {
          this.isAgree = true;
        }
      } else {
        // 不做任何修改，保持isAgree原值
      }
    },
    /**
     * @method handlePaymentSubmit
     * @description 处理支付提交
     */
    handlePaymentSubmit() {
      // 这里可以添加支付提交前的逻辑
    },
    /**
     * @method handlePaymentChange
     * @description 处理支付表单的完成状态
     */
    handlePaymentChange(state) {
      console.log("PC端接收到Payment data changed:", state);

      // 不要修改isAgree的值，而是单独使用一个变量来跟踪表单状态
      this.isFormValid = state.isValid || false;
      console.log("更新isFormValid为:", this.isFormValid);

      // 处理支付数据
      if (state.data && state.data.paymentMethod) {
        console.log("收到支付方法数据，正在处理");
        try {
          // 深拷贝支付方法数据，避免引用问题
          const paymentMethod = JSON.parse(
            JSON.stringify(state.data.paymentMethod)
          );

          // 删掉不需要的字段
          if (paymentMethod && paymentMethod.checkoutAttemptId) {
            delete paymentMethod.checkoutAttemptId;
          }

          // 保存为JSON字符串
          this.extendParam = JSON.stringify(paymentMethod);
          console.log("处理后的支付数据已准备好:", this.extendParam);
        } catch (error) {
          console.error("处理支付数据时出错:", error);
          this.extendParam = "{}";
        }
      }
    },
    /**
     * @method handlePaymentCompleted
     * @description 处理支付完成
     */
    handlePaymentCompleted(result) {
      console.log("Payment completed:", result);
      // 这里可以添加支付完成后的逻辑，如跳转到成功页面
      const successMsg = this.$t("common.paymentSuccess") || "支付成功";

      // 如果是英文，则分行处理
      if (this.$i18n.locale === "en") {
        // 分割文本成两行
        const words = successMsg.split(" ");
        // 使用换行符分隔单词
        const formattedMsg = `${words[0]}\n${words[1] || ""}`;

        Toast.success({
          message: formattedMsg,
          className: "toast-wrap"
        });
      } else {
        // 非英文直接显示
        Toast.success({
          message: successMsg,
          className: "toast-wrap"
        });
      }

      this.subscriptionQueryOrder();
    },
    /**
     * @method handlePaymentError
     * @description 处理支付错误
     */
    handlePaymentError(error) {
      console.error("Payment error:", error);
      Toast.fail({
        message: error.message || "支付处理出错，请稍后再试",
        className: "custom-toast-wide"
      });
    },
    /**
     * @method closeAchPayment
     * @description 关闭ACH支付
     */
    closeAchPayment() {
      this.showAchPayment = false;
    },
    /**
     * @method cardSelected
     * @description 选择银行卡
     */
    cardSelected(card) {
      console.log(card, "====card");
      this.bankAccountToken = card.bankAccountToken;
      this.reportLog({
        eventId: "SELECTCARD_PC",
        msg: this.checkoutValue
      });
    },

    /**
     * @method deleteCard
     * @description 删除银行卡后重新获取卡列表
     */
    deleteCard(deletedCard) {
      console.log("删除的卡片:", deletedCard);
      // 重新获取银行卡列表
      this.fetchCardList();
      this.reportLog({
        eventId: "DELETECARD_SUCCESS_PC",
        msg: this.checkoutValue,
      });
    },

    /**
     * @method handleAirwallexSuccess
     * @description 处理Airwallex支付成功
     */
    handleAirwallexSuccess(result) {
      console.log("Airwallex payment success:", result);
      // 查询订单状态
      this.subscriptionQueryOrder();
    },

    /**
     * @method handleAirwallexError
     * @description 处理Airwallex支付错误
     */
    handleAirwallexError(error) {
      console.error("Airwallex payment error:", error);
      // Toast.fail(error.message);

      Toast.fail({
        message: error.message,
        className: "custom-toast-wide",
        duration: 3000
      });
      // 可以添加错误处理逻辑
      this.subStatusResult(2);
      this.reportLog({
        eventId: "PAYERROR_PC",
        msg: this.checkoutValue
      });
    },

    /**
     * @method handleAirwallexInitialized
     * @description 处理Airwallex初始化完成
     */
    handleAirwallexInitialized() {
      console.log("Airwallex initialized successfully");
      this.loading = false;
    }
  },
  mounted() {
    this.payWayConfigList();
    // 如果路由有caseNumber参数，则调用handleSubscriptionPaymentCase
    if (utils.getUrlSearch("caseNumber")) {
      this.handleSubscriptionPaymentCase();
    } else {
      this.setGoodInfo();
    }
    // this.setGoodInfo();
    console.log(this.$i18n.locale, "this.$i18n.locale");
    if (this.$i18n.locale === "en") {
      this.languageTitle = "English";
      this.$i18n.locale = "en";
      this.languagekey = "0";
    } else if (this.$i18n.locale === "zh") {
      this.languageTitle = "简体中文";
      this.$i18n.locale = "zh";
      this.languagekey = "1";
    } else if (this.$i18n.locale === "fr") {
      this.languageTitle = "Français";
      this.$i18n.locale = "fr";
      this.languagekey = "2";
    } else if (this.$i18n.locale === "ja") {
      this.languageTitle = "日本語";
      this.$i18n.locale = "ja";
      this.languagekey = "3";
    } else if (this.$i18n.locale === "ko") {
      this.languageTitle = "한국어";
      this.$i18n.locale = "ko";
      this.languagekey = "4";
    }
    // this.loadAirwallexScript();
    this.reportLog({
      eventId: "OPENCHECKOUT_PC",
      msg: ""
    });
  },
  // Generated by AI start - Cursor - 2024-12-19
  beforeDestroy() {
    // 清理所有定时器，防止内存泄漏
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (this.queryInterval) {
      clearInterval(this.queryInterval);
      this.queryInterval = null;
    }
    if (this.subscriptionQueryInterval) {
      clearInterval(this.subscriptionQueryInterval);
      this.subscriptionQueryInterval = null;
    }
    if (this.queryStatus) {
      clearInterval(this.queryStatus);
      this.queryStatus = null;
    }
  }
  // Generated by AI end
};
</script>
<style lang="less">
.pcBox {
  width: 100%;
  height: 100%;
  .pcBox-header {
    width: 100%;
    height: 100px;
    background-color: #fff;
    border-bottom: 4px solid #ffaa0a;
    & > div {
      width: 1180px;
      height: 48px;
      padding: 26px 0;
      margin: 0 auto;
      span {
        vertical-align: middle;
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
      .logo {
        width: 48px;
        height: 48px;
        display: inline-block;
        background: url("../../assets/pc/logo_Cashier@2x.png") no-repeat;
        background-size: 48px;
      }
      .div_select_right {
        float: right;
        margin-top: 5px;
        display: flex;
        align-items: center;
        .div_close_button {
          margin-left: 10px;
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 10px;
          background: rgba(252, 252, 252, 0.2);
          border: 1px solid rgba(121, 119, 119, 0.2);
          transition: all 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.5);
          }

          .close-icon {
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .el-select {
          width: 160px !important;
          .el-input {
            border-radius: 8px;
            .el-input__inner {
              border-radius: 8px;
              // border: 1px solid #ffaa0a;
            }
          }
          .is-focus .el-input__inner,
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-input__inner:hover {
            border-color: #dcdfe6;
            // box-shadow: 0 0 0 2px rgba(255, 170, 10, 0.2);
          }
        }
      }
      .div_right {
        height: 30px;
        line-height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 16px;
        margin-top: 8px;
        padding: 0px 12px;
        cursor: pointer;
        span {
          color: rgba(102, 102, 102, 1) !important;
          font-size: 14px !important;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
        .lgIcon {
          width: 16px;
          height: 16px;
          display: inline-block;
          background: url("../../assets/pc/switch_pc.svg") no-repeat;
          background-size: 100%;
        }
      }
      .div_right:hover {
        background: rgba(240, 240, 240, 1);
      }
    }
  }
  .pcBox-center {
    width: 1100px;
    margin: 24px auto;
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;
    .topStatus {
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(226, 226, 226, 1);
      .top {
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .statusIcon {
          width: 24px;
          height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
          }
          .success-icon {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #ffaa0a;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .success-icon .check svg {
            display: block;
          }
        }
        .statusText {
          font-size: 24px;
          line-height: 24px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          margin-left: 12px;
        }
        .div_right {
          line-height: 24px;
        }
      }
      .timeBox {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 36px;
        margin-top: 16px;
        span {
          font-weight: 600;
          color: rgba(255, 121, 40, 1);
        }
      }
    }
    .botGoods {
      padding-top: 24px;
      display: flex;
      gap: 24px;
      align-items: stretch; // 让子项等高对齐
      .goods-left {
        flex: 1 1 0;
        display: flex; // 使内部卡片能充满高度
      }
      .goods-right {
        flex: 1 1 0;
        display: flex; // 使内部卡片能充满高度
      }
      .info-card {
        background: #f7f8fa;
        border-radius: 12px;
        padding: 20px;
        flex: 1;
        box-sizing: border-box;
        height: 100%;
      }
      /* 使 info-card 内每个字段的左右元素改为上下排列，独占一行 */
      .info-card .part {
        display: block;
      }
      .info-card .part .div_left,
      .info-card .part .div_right {
        float: none;
      }
      .info-card .part .leftTitle,
      .info-card .part .rightInfo {
        display: block;
        margin: 0;
      }
      .info-card .part .rightInfo {
        margin-top: 8px;
        line-height: 22px;
      }
      .part {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 16px;
        .leftTitle {
          display: inline-block;
          line-height: 24px;
          margin-right: 24px;
          color: rgba(102, 102, 102, 1);
        }
        .rightInfo {
          color: rgba(51, 51, 51, 1);
          word-wrap: break-word;
          word-break: break-all;
          line-height: 24px;
        }
      }

      .recurring-card {
        background: #f7f8fa;
        border-radius: 12px;
        padding: 24px;
        flex: 1;
        box-sizing: border-box;
        height: 100%;
      }
      .rec-title {
        font-size: 16px;
        font-weight: 500;
        color: #666;
        margin-bottom: 16px;
      }
      .rec-row {
        display: flex;
        font-size: 14px;
        color: #666;
        line-height: 20px;
        margin-bottom: 6px;
      }
      .rec-label {
        color: #666;
      }
      .rec-value {
        flex: 1;
        color: #333;
      }
      .rec-desc {
        align-items: flex-start;
      }
      .rec-price {
        margin-top: 12px;
      }
      .price-line {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .currency {
        font-size: 18px;
        color: #ff7928;
      }
      .amount {
        font-size: 28px;
        font-weight: 700;
        color: #ff7928;
      }
      .offer-badge {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 90px;
        height: 18px;
        padding: 0; /* 让 SVG 背景完整覆盖 */
        color: #fff;
        border-radius: 9px;
        font-size: 10px;
        font-weight: 700;
        line-height: 18px;
        vertical-align: middle;
        margin-left: 8px;
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="90" height="18" viewBox="0 0 90 18" fill="none"><path d="M2.99993 4.00001C2.99993 1.79087 4.79079 0 6.99993 0H85.9999C88.2091 0 89.9999 1.79086 89.9999 4V14C89.9999 16.2091 88.2091 18 85.9999 18H6.99993C4.79079 18 2.99993 16.2091 2.99993 14C2.99993 12.741 2.40717 11.5554 1.39996 10.8L1.13328 10.6C0.0666355 9.79999 0.0666343 8.20001 1.13328 7.40001L1.39996 7.2C2.40717 6.44458 2.99993 5.25903 2.99993 4.00001Z" fill="%23FA6000"/></svg>')
          no-repeat center/cover;
        white-space: nowrap;
      }
      .thereafter {
        margin-top: 4px;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .pcBox-footer {
    padding: 40px;
    background: #fff;
    width: 1100px;
    margin: 0 auto;
    border-radius: 8px;
    margin-bottom: 100px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      margin-bottom: 24px;
    }
    .payWays {
      .part {
        // display: flex;
        width: 370px;
        // min-height: 46px;
        padding: 16px 20px;
        border-radius: 8px;
        margin-bottom: 16px;
        border: 1px solid rgba(204, 204, 204, 1);
        cursor: pointer;
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .payIcon {
          height: 48px;
          img {
            height: 100%;
          }
        }
        .payPro {
          min-height: 48px;
          line-height: 48px;
          color: rgba(51, 51, 51, 1);
          margin-left: 16px;
          .van-cell {
            padding: 0 !important;
            min-height: 48px;
            font-size: 16px;
            font-weight: 400;
            background-color: rgba(0, 0, 0, 0);
          }
        }
        .tip {
          color: #969799;
          font-size: 12px;
          line-height: 18px;
        }
      }
      .hoverPart:hover {
        border: 1px solid #ffaa0a !important;
      }
    }
    .payBtn {
      width: 220px;
      height: 40px;
      background: #ffaa0a;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      // margin-top: 40px;
    }
    .payBtn:hover {
      background: #ec9d0a;
    }
    .paybtn-wrap {
      position: absolute;
    }
    .resultIcon {
      width: 140px;
      height: 140px;
      margin: 20px auto 16px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .resultText {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 20px;
      font-size: 18px;
      .result-icon {
        margin-bottom: 12px;
        img {
          width: 48px;
          height: 48px;
        }
      }

      .result-message {
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      span {
        color: #1082ff;
        cursor: pointer;
      }
    }
  }
  .loadingBox {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 1);
      opacity: 0.5;
    }
    .centerBox {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 144px;
      height: 106px;
      padding: 20px 0;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      img {
        display: block;
        width: 80px;
        height: 80px;
        margin: 0 auto;
      }
      & > div {
        text-align: center;
        margin-top: 12px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }
    }
  }
  .payResultBox {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 1);
      opacity: 0.5;
    }
    .payResultCenterBox {
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      .title {
        height: 24px;
        padding: 10px 12px 10px 14px;
        background: rgba(248, 248, 248, 1);
        border-radius: 8px 8px 0px 0px;
        .div_left {
          font-size: 16px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          vertical-align: middle;
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: -3px;
          }
        }
        .div_right {
          span {
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-top: 2px;
            cursor: pointer;
            background: url("../../assets/pc/fork_popup.svg") no-repeat;
            background-size: 100%;
          }
          span:hover {
            background: url("../../assets/pc/fork_popup_hower.svg") no-repeat;
            background-size: 100%;
          }
        }
      }
      .centerContent {
        padding: 32px 45px;
        .qrcode {
          width: 200px;
          height: 200px;
          display: block;
          margin: 0 auto;
        }
        .botText {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-top: 8px;
          span {
            font-weight: 600;
            color: rgba(255, 121, 40, 1);
          }
        }
      }
    }
  }
}
.ali-hk-frame {
  /* padding-left: 44px; */
}
.mol_tip {
  margin-bottom: 10px;
}
#molpay_ebanking_fpx_MY-container {
  width: 412px;
  margin-bottom: 16px;
  cursor: pointer;
  .adyen-checkout__dropdown__button {
    padding-left: 22px !important;
    border-color: rgb(204, 204, 204);
    border-color: rgb(255, 170, 10);
    box-sizing: border-box;
  }
  .Select-module_adyen-checkout__dropdown__button__yTyqq:after {
    right: 10px !important;
  }
  .adyen-checkout__dropdown__element__icon {
    max-height: 20px;
  }
  .adyen-checkout__dropdown__element__text {
    font-size: 14px;
    font-weight: bold;
  }
  input {
    cursor: pointer;
  }
}

.googleOrApplePayButton {
  width: 260px;
  height: 40px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  margin: 32px auto 0;
}
.googleOrApplePayButton-wrap {
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 40px 16px 24px;
  text-align: center;
  .tips {
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
  .apple-pay-subscription-tip {
    margin: 16px auto 0;
    color: #666;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }
}
.loading-img {
  width: 30px;
  height: 30px;
  margin: 32px auto 0;
  -webkit-transform: rotate(360deg);
  animation: rotation 2s linear infinite;
  -moz-animation: rotation 2s linear infinite;
  -webkit-animation: rotation 2s linear infinite;
  -o-animation: rotation 2s linear infinite;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.payBtn-group {
  margin-top: 40px;
}
.agreement-group {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  // 协议文本样式
  font-size: 14px;
  color: #666;

  .agreement-text {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-left: 10px;
  }
}
.van-checkbox__icon--checked .van-icon {
  border-radius: 50%;
  background-color: #ffaa0a;
  border-color: #ffaa0a;
}
.van-checkbox__icon .van-icon {
  border-radius: 50%;
}
.logo_wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  // justify-content: center;
}

/* Toast 宽度优化 - 使用更强的选择器 */
</style>

<style>
/* 全局 Toast 样式 - 不使用 scoped，针对 Vant Toast 的实际 DOM 结构 */

/* Toast 容器样式 */
.van-toast.custom-toast-wide {
  max-width: calc(100vw - 40px) !important;
  min-width: 300px !important;
  width: auto !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  padding: 16px 20px !important;
  margin: 0 20px !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

/* Toast 文本样式 */
.van-toast.custom-toast-wide .van-toast__text {
  max-width: none !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
  text-align: left !important;
  overflow-wrap: break-word !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
}

/* 确保 Toast 在屏幕中央且有足够的层级 */
.van-overlay + .van-toast.custom-toast-wide {
  z-index: 9999 !important;
}
.refresh-icon-container {
  text-align: center;
  padding-top: 10px !important;
  .refresh-icon {
    cursor: pointer;
    color: #999 !important;
    font-size: 14px;
  }
}
</style>
